module.exports = __webpack_public_path__ + "static/media/IMG_0229_1622991527574.a4d67d27.jpeg";